import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ReplaceItemsCommand from './replaceItemsCommand';

/**
 * Switch item version command
 *
 * @class SetItemAccessoryCommand
 * @extends AbstractCommand
 */
export default class SwitchItemVersionCommand extends ReplaceItemsCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Switch version of ${this.replacements.length} items`;
        }
        return 'Switch version of item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SwitchItemVersionCommand = SwitchItemVersionCommand;
